// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active[data-v-04cdbae2]{border:2px solid var(--clr-primary)}", ""]);
// Exports
module.exports = exports;
